import styled from "styled-components";

export const StyledForm = styled.form`
 background: var(--bg-paper);
 text-align: left;
 padding: 5px; 
 width: 310px;
 border-radius: var(--root-br);
 padding: 15px;
`;
